import { Outlet } from 'react-router-dom'

import { ProductHeader } from '@/app/entities/product/ui'

export const ProductLayout = () => {
    return (
        <div className='flex-col flex-1'>
            <ProductHeader />
            <Outlet />
        </div>
    )
}
